export default function NotFound() {
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>404 - Not Found</h2>
        <p>Sorry, the page you are looking for does not exist.</p>
        <img
            src="https://i.giphy.com/qQdL532ZANbjy.webp"
            alt="Not Found GIF"
            style={{ width: '300px', height: '300px', margin: '20px' }}
        />
    </div>;
}